<template>
  <div>
    <div class="table-ad-1-tickets">
      <component :tickets="tickets" :layout="convertLayout" :is="component"/>
    </div>
    <div class="table-ad-1-ads">
      <AdPlayList v-if="playlistBottomItems.length > 0" :play-list-items="playlistBottomItems" :full-screen="false"/>
    </div>
  </div>
</template>

<script>
import TableSimple from '@/components/table/TableSimple'
import TableCols from '@/components/table/TableCols.vue'
import AdPlayList from '@/components/playlist/AdPlayList.vue'
import { mapState } from 'vuex'
import { layouts } from '@/app/const/settings'

export default {
  name: 'TableVerticalAd',
  components: {
    AdPlayList,
    TableSimple,
    TableCols
  },
  props: {
    tickets: {
      type: Array
    },
    layout: {
      type: String
    }
  },
  computed: {
    ...mapState({
      playlistBottomItems: state => state.playlist.adItems ? state.playlist.adItems.playlistsBottomItems : []
    }),
    convertLayout () {
      return this.layout === layouts.col2Ad ? layouts.col2 : this.layout
    },
    component () {
      return this.layout === layouts.col2Ad ? TableCols : TableSimple
    }
  }
}
</script>
